function initToggleBlocks() {
  const toggleButtons = document.querySelectorAll('.toggle_button');

  toggleButtons?.forEach(function (toggleButton) {
    toggleButton.addEventListener('click', function (e) {
      const toggleParent = this.closest('.toggle_parent');

      if (!toggleParent) {
        return;
      }

      const toggleBlock = toggleParent.querySelector('.toggle_block');

      if (!toggleBlock) {
        return;
      }

      if (toggleBlock.classList.contains('d-none')) {
        this.classList.add('show');
        toggleBlock.classList.remove('d-none');
      } else {
        this.classList.remove('show');
        toggleBlock.classList.add('d-none');
      }
    });
  });
}

export { initToggleBlocks }